import * as React from 'react'

import TableCheckbox from '@/modules/drivers/shared/tableItems/TableCheckbox'
import TableTextRow from '@/modules/drivers/shared/tableItems/TableTextRow'
import { formatTripTimespan } from '@/app/common/dateHelper'
import { getCountryFlag } from '@/app/services/country/countryFlagResolver'
import Tooltip from '@/modules/drivers/shared/ToolTip'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import {
  faBaconRegular,
  faBaconSolid,
  faBowlHotRegular,
  faBowlHotSolid,
  faPotFoodRegular,
  faPotFoodSolid,
  FaIcon,
} from '@/lib/fa'

type AlimentationRowItemProps = {
  al: any
  isChecked: boolean
  toggleId: (id: number) => void
  originalIndex: number
  onUpdateField: (field: string, value: any) => void
}

const AlimentationRowItem: React.FC<AlimentationRowItemProps> = ({
  al,
  isChecked,
  toggleId,
  originalIndex,
  onUpdateField,
}) => {
  const { tSafe } = useLocalize()



  const renderParticleIcon = (
    field: string,
    tooltip: string,
    icons: { regular: any; solid: any },
  ) => {
    const active = Boolean(al[field])
    return (
      <td className="tw-px-1 tw-py-2.5" onClick={(e) => e.stopPropagation()}>
        <div className="tw-flex tw-items-center tw-justify-center">
          <Tooltip text={tooltip}>
            <FaIcon
              icon={active ? icons.solid : icons.regular}
              onClick={() => onUpdateField(field, !active)}
              className={`tw-cursor-pointer ${
                active
                  ? 'tw-text-primary'
                  : 'tw-text-gray-400 tw-opacity-80 hover:tw-opacity-100'
              }`}
            />
          </Tooltip>
        </div>
      </td>
    )
  }

  return (
    <tr
      className="hover:tw-bg-base-50 tw-cursor-pointer"
      onClick={() => toggleId(originalIndex)}
    >
      <td onClick={(e) => e.stopPropagation()}>
        <TableCheckbox
          checked={isChecked}
          onChange={() => toggleId(originalIndex)}
          disabled={false}
        />
      </td>

      {/* country */}
      <TableTextRow
        icon={
          al.country?.code ? (
            <img
              src={getCountryFlag(
                al.country.code.toUpperCase() === 'GB'
                  ? 'EN'
                  : al.country.code,
              )}
              width={18}
              height={18}
              alt=""
              className="tw-mr-0"
            />
          ) : null
        }
      >
        {al.country?.name || '-'}
      </TableTextRow>

      {/* tripLenght (read-only) */}
      <TableTextRow>
        {al.tripLenght ? formatTripTimespan(al.tripLenght) : '-'}
      </TableTextRow>

      {/* dietQuantity (read-only) */}
      <TableTextRow>{al.dietQuantity || '-'}</TableTextRow>

      {/* breakfasts */}
      <td className="tw-px-4 tw-py-3.5" onClick={(e) => e.stopPropagation()}>
        <input
          type="number"
          value={al.breakfasts || 0}
          onChange={(e) =>
            onUpdateField('breakfasts', parseInt(e.target.value) || 0)
          }
          className="tw-w-full tw-rounded tw-py-1 tw-text-sm focus:tw-outline-none"
        />
      </td>

      {/* dinners */}
      <td className="tw-px-4 tw-py-3.5" onClick={(e) => e.stopPropagation()}>
        <input
          type="number"
          value={al.dinners || 0}
          onChange={(e) =>
            onUpdateField('dinners', parseInt(e.target.value) || 0)
          }
          className="tw-w-full tw-rounded tw-py-1 tw-text-sm focus:tw-outline-none"
        />
      </td>

      {/* suppers */}
      <td className="tw-px-4 tw-py-3.5" onClick={(e) => e.stopPropagation()}>
        <input
          type="number"
          value={al.suppers || 0}
          onChange={(e) =>
            onUpdateField('suppers', parseInt(e.target.value) || 0)
          }
          className="tw-w-full tw-rounded tw-py-1 tw-text-sm focus:tw-outline-none"
        />
      </td>

      {/* Trailing icon-only columns for partial meals — each meal gets a
          distinct food icon so they're tellable apart even without a header
          label. */}
      {renderParticleIcon(
        'breakfastInParticle',
        tSafe(
          'businessTrip.col-breakfasts-partial',
          'Śniadanie w częściowej diecie',
        ),
        { regular: faBaconRegular, solid: faBaconSolid },
      )}
      {renderParticleIcon(
        'dinnerInParticle',
        tSafe('businessTrip.col-dinners-partial', 'Obiad w częściowej diecie'),
        { regular: faPotFoodRegular, solid: faPotFoodSolid },
      )}
      {renderParticleIcon(
        'supperInParticle',
        tSafe(
          'businessTrip.col-suppers-partial',
          'Kolacja w częściowej diecie',
        ),
        { regular: faBowlHotRegular, solid: faBowlHotSolid },
      )}
    </tr>
  )
}

export default AlimentationRowItem
